var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensoriW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.3729C15.8864 20.3729 16.605 19.6523 16.605 18.7634C16.605 17.8744 15.8864 17.1538 15 17.1538C14.1136 17.1538 13.395 17.8744 13.395 18.7634C13.395 19.6523 14.1136 20.3729 15 20.3729Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.8555V27.9232",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4281 7.42225C25.0115 3.94815 20.2601 1.79675 15.0002 1.79675C9.74026 1.79675 4.98884 3.94815 1.57227 7.42225",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0115 10.8645C22.4689 8.26691 18.9252 6.65735 15.0001 6.65735C11.075 6.65735 7.53133 8.26691 4.98877 10.8645",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5792 14.3067C19.9106 12.5856 17.5746 11.5178 15.0003 11.5178C12.4259 11.5178 10.0899 12.5856 8.42139 14.3067",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensoriW);
export default __webpack_public_path__ + "static/media/sensoriW.48ac964770a2a3731b25c2dd05b9c24b.svg";
export { ForwardRef as ReactComponent };